import * as React from 'react';
import clx from 'classnames';
import { Space, Tag, Typography } from 'antd';
import './ProcedureSummary.scss';
import { IProcedure } from 'common/schema/Procedure';
import { ProcedureStateTag } from 'client/components/schema/procedures/status/ProcedureStateTag';
import { ProcedureRecipientTitle } from 'client/components/schema/procedures/recipient/ProcedureRecipientTitle';
import { ProcedureRecipientIcon } from 'client/components/schema/procedures/recipient/ProcedureRecipientIcon';
import { LabeledDate } from 'client/ui/display/date/LabeledDate';
import { useConfigRecipientEnabled } from 'client/components/schema/procedures/hooks/useConfigRecipientEnabled';
import { CountdownHumanized } from 'client/ui/display/countdown/CountdownHumanized';
import { useThemeConfig } from 'client/components/schema/config/ClientConfigModule';
import { ProcedureLogic } from 'common/schema/ProcedureLogic';
const { Text } = Typography;

export interface ProcedureSummaryProps {
  procedure: IProcedure;
}

export function ProcedureSummary(props: ProcedureSummaryProps) {
  const procedure = props.procedure;
  const recipientEnabled = useConfigRecipientEnabled();
  const { options } = useThemeConfig();

  return (
    <Space direction="vertical" size={12} className="procedure-summary">
      {recipientEnabled && (
        <div
          className={clx(
            'procedure-recipient',
            procedure.recipient.toLowerCase()
          )}
        >
          <ProcedureRecipientIcon recipient={procedure.recipient} />
          <ProcedureRecipientTitle recipient={procedure.recipient} />
        </div>
      )}
      <ProcedureStateTag procedure={procedure} />
      {procedure.activeEnabledUsers && (
        <Text type="secondary">Istanza ad accesso limitato</Text>
      )}
      <LabeledDate
        label="Decorrenza"
        date={procedure.activatedAt}
        format="DD/MM/YYYY HH:mm"
      />
      <LabeledDate
        label="Scadenza"
        date={ProcedureLogic.getRenderableDateWith24Hour(procedure.expiresAt)}
        format={`DD/MM/YYYY kk:mm`}
      />
      {options.showCountdown && (
        <CountdownHumanized expireDate={procedure.expiresAt} />
      )}
      <div className="procedure-categories">
        {procedure.categories.map((category, i) => (
          <Tag key={i}>{category}</Tag>
        ))}
      </div>
    </Space>
  );
}
